import { render, staticRenderFns } from "./auto-validate-date-field.vue?vue&type=template&id=ddbded28&"
import script from "./auto-validate-date-field.component.ts?vue&type=script&lang=js&"
export * from "./auto-validate-date-field.component.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports